export enum FontFamilyEnum {
  NOTO_SERIF = 'notoSerif',
  TRIRONG = 'trirong',
  SARABUN = 'sarabun',
  JS_JINDARA = 'jsJindara',
  BAI_JAMJUREE = 'baiJamjuree',
}
